/* Project Import will be here */
import { getEarnedPointsApi, getMonthlySalesApi, getSelectedPointDetailsApi } from "services/rbp/rbpService";
import { getErrorObject, errorToast } from "utilities/utils";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { getRewardDashboardApi } from "services/rewards/rewards";
/* Project Import will be here */

export const types = {
    EARNED_POINTS_REQUEST: "myEarningsLedger/EARNED_POINTS_REQUEST",
    EARNED_POINTS_SUCCESS: "myEarningsLedger/EARNED_POINTS_SUCCESS",
    EARNED_POINTS_FAILURE: "myEarningsLedger/EARNED_POINTS_FAILURE",
    GET_REWARD_DASHBOARD_REQUEST: "myEarningsLedger/GET_REWARD_DASHBOARD_REQUEST",
    GET_REWARD_DASHBOARD_SUCCESS: "myEarningsLedger/GET_REWARD_DASHBOARD_SUCCESS",
    GET_REWARD_DASHBOARD_FAILURE: "myEarningsLedger/GET_REWARD_DASHBOARD_FAILURE",
    MONTHLY_SALES_REQUEST: "monthlySalesData/MONTHLY_SALES_REQUEST",
    MONTHLY_SALES_SUCCESS: "monthlySalesData/MONTHLY_SALES_SUCCESS",
    MONTHLY_SALES_FAILURE: "monthlySalesData/MONTHLY_SALES_FAILURE",
    REWARD_POINTS_DETAILS_REQUEST: "myEarningsLedger/REWARD_POINTS_DETAILS_REQUEST",
    REWARD_POINTS_DETAILS_SUCCESS: "myEarningsLedger/REWARD_POINTS_DETAILS_SUCCESS",
    REWARD_POINTS_DETAILS_FAILURE: "myEarningsLedger/REWARD_POINTS_DETAILS_FAILURE",
};

const initialState = {
    isLoading: false,
    data: [],
    rewardData: {},
    monthlySalesData: {
        isLoading: false,
        data: {}
    },
    rewardsPointsDetailsData: {
        data: [],
        isLoading: false
    }
};

export const myEarningsLedger = (state = initialState, action) => {
    switch (action.type) {
        case types.EARNED_POINTS_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }
        case types.EARNED_POINTS_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };
        }
        case types.EARNED_POINTS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                data: []
            };
        }
        case types.GET_REWARD_DASHBOARD_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }
        case types.GET_REWARD_DASHBOARD_SUCCESS: {
            return {
                ...state,
                ...action.payload
            };
        }
        case types.GET_REWARD_DASHBOARD_FAILURE: {
            return {
                ...state,
                rewardData: {}
            };
        }
        case types.MONTHLY_SALES_REQUEST: {
            return {
                ...state,
                monthlySalesData: {
                    ...state.monthlySalesData,
                    isLoading: true
                }
            };
        }
        case types.MONTHLY_SALES_SUCCESS: {
            return {
                ...state,
                monthlySalesData: {
                    data: action.payload,
                    isLoading: false
                }
            };
        }
        case types.MONTHLY_SALES_FAILURE: {
            return {
                ...state,
                monthlySalesData: {
                    ...initialState.monthlySalesData
                }
            };
        }
        case types.REWARD_POINTS_DETAILS_REQUEST: {
            return {
                ...state,
                rewardsPointsDetailsData: {
                    ...state.rewardsPointsDetailsData,
                    isLoading: true
                }
            };
        }
        case types.REWARD_POINTS_DETAILS_SUCCESS: {
            return {
                ...state,
                rewardsPointsDetailsData: {
                    data: action.payload,
                    isLoading: false
                }
            };
        }
        case types.REWARD_POINTS_DETAILS_FAILURE: {
            return {
                ...state,
                rewardsPointsDetailsData: {
                    ...initialState.rewardsPointsDetailsData
                }
            };
        }
        default:
            return state;
    }
};

/* Get last 12 month earning ledger data */
export const getEarnedPointsDetails = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.EARNED_POINTS_REQUEST });
        try {
            const response = await getEarnedPointsApi();
            dispatch({
                type: types.EARNED_POINTS_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.EARNED_POINTS_FAILURE));
        }
    };
};

/* Get monthly sales details for each cycle data */
export const getMonthlySalesDetails = (reqObj) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.MONTHLY_SALES_REQUEST });
        try {
            const response = await getMonthlySalesApi(reqObj);
            dispatch({
                type: types.MONTHLY_SALES_SUCCESS,
                payload: response.data.Data
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.MONTHLY_SALES_FAILURE));
        }
    };
};

/* Get retailer current active reward points */
export const getRewardDashboardDetails = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.GET_REWARD_DASHBOARD_REQUEST });
        try {
            const response = await getRewardDashboardApi();
            dispatch({
                type: types.GET_REWARD_DASHBOARD_SUCCESS,
                payload: { rewardData: response.data.Data },
            });
        } catch (error) {
            dispatch(promiseCatchBlock(error, types.GET_REWARD_DASHBOARD_FAILURE));
        }
    };
};

/* Get points details */
export const getSelectedPointDetails = (data) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.REWARD_POINTS_DETAILS_REQUEST });
        try {
            const response = await getSelectedPointDetailsApi(data);
            dispatch({
                type: types.REWARD_POINTS_DETAILS_SUCCESS,
                payload: response.data.Data
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.POINTS_DETAILS_FAILURE));
        }
    };
};

const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "")
            dispatch({ type: type, payload: { error: message } });

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};